import React from "react"
import styled, { keyframes } from "styled-components";
import BreakpointUp from "../Media/BreakpointUp"

const MarkqueeRightToLeft = keyframes`
    0%   { transform: translate(0, 0); }
    100% { transform: translate(-100%, 0); }
`;

const MarkqueeWrap = styled.div`
    display: block;
    height: 30px;
    width: 100%;
    background:#373636;
    padding: 5px;
    color: #fff;
    position: fixed;
    z-index: 10;
    top: 64px;
    font-size: 14px;
    line-height: 20px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 8px 25px;
    @media (min-width: 1200px) {
        font-size: 16px;
        line-height: 20px;
    }
    ${BreakpointUp.xl`
        top:100px;
    `}
    & a{
        font-weight:700;
        color:#fff;
        font-size: 14px;
        line-height: 1;
        &:hover, &:focus{
            color:#E9242A;
        }
    }
`
const Markquee = styled.div`   
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    text-align:center;
`
const SiteMarkquee = styled.div`
    display: inline-block; 
    padding-left: 100%;
    animation-duration: 25s;
    animation-name: ${MarkqueeRightToLeft};
    animation-iteration-count:infinite;
    animation-timing-function: linear;
    &:hover { 
        animation-play-state: paused; 
    }
`


const Markquees = () => {
  return (
    <MarkqueeWrap className="markquee">
        <div className="container">
            <Markquee>
                <SiteMarkquee>Metal Building Prices Are Rising – Call <a href="tel:8666817846" aria-label="2085721441">(208) 572-1441</a> to Lock in Today's Pricing!</SiteMarkquee>
            </Markquee>
        </div>
    </MarkqueeWrap>
  )
}

export default Markquees